<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <dx-toolbar class="theme-dependent">
            <dxi-item location="before">
                <div class="header-text">HALB Details</div>
            </dxi-item>
            <dxi-item location="after" locateInMenu="never">
                <dx-button
                    text="Back"
                    stylingMode="outlined"
                    type="normal"
                    (onClick)="cancel()"
                >
                </dx-button>
                <dx-button
                    class="ms-2"
                    text="Save"
                    stylingMode="contained"
                    type="default"
                    (onClick)="save()"
                >
                </dx-button>
            </dxi-item>
        </dx-toolbar>
    </div>

    <dx-load-panel
        container=".view-wrapper-scroll"
        [visible]="isLoading"
        [showPane]="false"
        [position]="{ of: 'halb-details' }"
    >
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll">
        @if (!isLoading) {
            <div class="form-container">
                <div class="card border-0 shadow-sm pt-0">
                    <div class="card-header fs-5 fw-medium d-flex justify-content-between align-items-center bg-transparent py-3">
                        <div>{{ halb.description }}</div>
                        @if (halb.number) {
                            <div class="text-muted">
                                ID: {{ halb.number }}
                            </div>
                        }
                    </div>
                    <div class="card-body">
                        <div class="row g-3 mb-3">
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <span class="fw-bold">Description:</span> {{ halb.description }}
                                </div>
                                <div class="mb-3">
                                    <span class="fw-bold">Material Type:</span> {{ halb.materialType }}
                                </div>
                                <div class="mb-3">
                                    <span class="fw-bold">MDR Record Owner:</span> {{ halb.mdrRecordOwner }}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <span class="fw-bold">IMSP Shared:</span> {{ halb.imspShared }}
                                </div>
                                <div class="mb-3">
                                    <span class="fw-bold">Full Pallet:</span> {{ halb.fullPallet }}
                                </div>
                            </div>
                        </div>

                        <div class="row g-3 mb-4">
                            <div class="col-md-6">
                                <div>
                                    <label class="form-label">Revised Storage Type:</label>
                                    <dx-select-box
                                        [(value)]="halb.storageType"
                                        [dataSource]="storageTypeOptions"
                                        [showClearButton]="true"
                                        displayExpr="text"
                                        valueExpr="value"
                                        width="100%"
                                        stylingMode="filled"
                                    ></dx-select-box>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div>
                                    <label class="form-label">Material Group:</label>
                                    <dx-select-box
                                        [(value)]="halb.materialGroup"
                                        [dataSource]="materialGroupOptions"
                                        [showClearButton]="true"
                                        [searchEnabled]="true"
                                        width="100%"
                                        stylingMode="filled"
                                    ></dx-select-box>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        }
    </dx-scroll-view>
</div>

